{ "closeAria": "Закрити", "historyAria": "Історія звернень", "supportTitle": "Підтримка" }
